import React, { useEffect, useRef, useState } from 'react';
import './Stats.css';

function Stats() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const stats = [
    { number: 50, suffix: '+', label: 'Successful Projects', description: 'Stores launched and growing' },
    { number: 99, suffix: '%', label: 'Client Satisfaction', description: 'Happy clients, every time' },
    { number: 5, prefix: '$', suffix: 'M+', label: 'Revenue Generated', description: 'For our clients' },
    { number: 150, suffix: '%', label: 'Average ROI', description: 'Within first 6 months' }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  const Counter = ({ end, duration, prefix = '', suffix = '' }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      if (!isVisible) return;

      let startTime;
      const animateCount = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const progress = timestamp - startTime;
        const percentage = Math.min(progress / duration, 1);

        const easeOut = 1 - Math.pow(1 - percentage, 3);
        setCount(Math.floor(end * easeOut));

        if (percentage < 1) {
          requestAnimationFrame(animateCount);
        }
      };

      requestAnimationFrame(animateCount);
    }, [isVisible, end, duration]);

    return <span>{prefix}{count}{suffix}</span>;
  };

  return (
    <section ref={sectionRef} className="stats-section">
      <div className="container">
        <div className="stats-grid fade-in">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-number">
                <Counter
                  end={stat.number}
                  duration={2000}
                  prefix={stat.prefix}
                  suffix={stat.suffix}
                />
              </div>
              <div className="stat-label">{stat.label}</div>
              <div className="stat-description">{stat.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Stats;
